import { Directive, Input, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[disableControl]' // Custom selector to apply the directive
    ,
    standalone: false
})
export class DisableControlDirective implements OnChanges {

    @Input() disableControl: boolean;

    constructor(@Optional() private ngControl: NgControl) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.ngControl?.control && changes['disableControl']) {
            if (this.disableControl) {
                this.ngControl.control.disable();  // Disable the control
            } else {
                this.ngControl.control.enable();   // Enable the control
            }
        }
    }
}
